// material-ui

import tractor2axles from '../../../assets/images/Truck/tractor-2-axles.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Tractor2Axles = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={tractor2axles} alt="Tractor 2 axles" height={props.height || 30}  />
    );
};

export default Tractor2Axles;